export const getMagnoliaBaseUrl = () => {
	const magnoliaBaseUrl = isCmsPreview()
		? process.env.MGNL_BASE_AUTHOR_URL
		: process.env.MGNL_BASE_PUBLIC_URL;
	return magnoliaBaseUrl;
};

export const getMagnoliaBaseDamUrl = () => {
	const magnoliaBaseDamUrl = isCmsPreview()
		? process.env.MGNL_BASE_DAM_AUTHOR_URL
		: process.env.MGNL_BASE_DAM_PUBLIC_URL;
	return magnoliaBaseDamUrl;
};

const CMS_PREVIEW_KEY = 'cmsPreview';
export function isCmsPreview(): boolean {
	const url = new URL(window.location.href);

	if (url.searchParams.has(CMS_PREVIEW_KEY)) {
		const previewParam = url.searchParams
			.get(CMS_PREVIEW_KEY)
			?.toLocaleLowerCase();
		const previewing = sessionStorage.getItem(CMS_PREVIEW_KEY);
		switch (previewParam) {
			case 'true':
			case '1':
			case '':
			case null:
				sessionStorage.setItem(CMS_PREVIEW_KEY, 'true');
				!previewing && console.log('CMS Preview mode enabled');
				break;
			case 'false':
			case '0':
				sessionStorage.removeItem(CMS_PREVIEW_KEY);
				previewing && console.log('CMS Preview mode disabled');
				break;
		}
	}

	return sessionStorage.getItem(CMS_PREVIEW_KEY) === 'true';
}

const APP_BASE_KEY = 'appBase';
export function getAppBase() {
	const url = new URL(window.location.href);

	if (url.searchParams.has(APP_BASE_KEY)) {
		const appBaseParam = url.searchParams.get(APP_BASE_KEY)?.trim();
		const storedAppBase = sessionStorage.getItem(APP_BASE_KEY);

		if (appBaseParam !== storedAppBase) {
			if (appBaseParam) {
				const normalizedAppBase = appBaseParam.startsWith('/')
					? appBaseParam
					: `/${appBaseParam}`;
				sessionStorage.setItem(APP_BASE_KEY, normalizedAppBase);
				console.log(`App base set to ${normalizedAppBase}`);
			} else {
				sessionStorage.removeItem(APP_BASE_KEY);
				console.log('App base reset to default');
			}
		}
	}

	return (
		sessionStorage.getItem('appBase') || process.env.MGNL_PAGES_APP_BASE || ''
	);
}
